const columns: TableColumn[] = [
  {
    Header: `Code`,
    accessor: `referenceCode`,
    dbKey: `referenceCode`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Trigger`,
    accessor: `trigger`,
    dbKey: `trigger`,
    isString: false,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `User`,
    accessor: `userName`,
    dbKey: `userName`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Email`,
    accessor: `userEmail`,
    dbKey: `userEmail`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Company`,
    accessor: `companyName`,
    dbKey: `companyName`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Version`,
    accessor: `extensionVersion`,
    dbKey: `extensionVersion`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Errors`,
    accessor: `totalErrors`,
    dbKey: `totalErrors`,
    isString: false,
    isNumeric: true,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Primary Category`,
    accessor: `primaryCategory`,
    dbKey: `primaryCategory`,
    isString: false,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Breakdown`,
    accessor: `breakdown`,
    dbKey: `summary`,
    isString: false,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Detections`,
    accessor: `detections`,
    dbKey: `recentDetections`,
    isString: false,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Timestamp`,
    accessor: `timestamp`,
    dbKey: `timestamp`,
    isString: false,
    isNumeric: false,
    isDate: true,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Top Errors`,
    accessor: `topErrors`,
    dbKey: `errors`,
    isString: false,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  }
];

export default columns;
